import { createSelector } from '@ngrx/store';
import { getNewModifyOrderState } from '../reducers';

export const getOrderSelectedDetailState = createSelector(getNewModifyOrderState, state => state && state.orderSelectedDetail);

export const getOrderSelectedDetail = createSelector(getOrderSelectedDetailState, state => state && state.order);

export const getOrderSelectedDetailPrices = createSelector(getOrderSelectedDetailState, state => state && state.prices);
export const getOrderSelectedDeliveryDay = createSelector(getOrderSelectedDetailState, state => state && state.isDeliveryToday);

export const getDisabledNavigation = createSelector(getNewModifyOrderState, state => {
  return state.modifyOrder.disableNavigation;
});

export const getOrderModifyFormsTopLocationState = createSelector(getNewModifyOrderState, state => {
  return state && state.topLocation.topLocationFormState.forms;
});
